export const noPermissions = {
  state: null,
  view: "NoPermissionsView",
  splashView: null,
};

export const setupComplete = {
  state: "setupComplete",
  view: "DashboardView",
  splashView: "setupComplete",
};

export const missingDataForSignup = {
  state: "missingDataForSignup",
  view: "IntroView",
  splashView: "learnMore",
};

export const needTosAgreement = {
  state: "needTosAgreement",
  view: "IntroView",
  splashView: "learnMore",
};

export const needToCreateFund = {
  state: "needToCreateFund",
  view: "SignupProgressView",
  splashView: "learnMore",
};

export const needToEnterKYC = {
  state: "needToEnterKYC",
  view: "SignupProgressView",
  splashView: "moreSetupNeeded",
};

export const needToEnterBankInfo = {
  state: "needToEnterBankInfo",
  view: "SignupProgressView",
  splashView: "moreSetupNeeded",
};

export const hasKYCValidationError = {
  state: "hasKYCValidationError",
  view: "SignupProgressView",
  splashView: "moreSetupNeeded",
};

export const waitingForKYCApproval = {
  state: "waitingForKYCApproval",
  view: "SignupProgressView",
  splashView: "moreSetupNeeded",
};

export const awaitingReactivation = {
  state: "awaitingReactivation",
  view: "IntroView",
  splashView: "moreSetupNeeded",
};

const fundItProgressData = {
  noPermissions,
  setupComplete,
  missingDataForSignup,
  needTosAgreement,
  needToCreateFund,
  needToEnterBankInfo,
  needToEnterKYC,
  hasKYCValidationError,
  waitingForKYCApproval,
  awaitingReactivation,
};

export default fundItProgressData;
